import React, { useEffect, useState, createContext, useContext } from 'react';
import { Product, ProductOption } from '../types/types';
import { CONFIG } from '../data/config';
import { MENU_PRODUCTS, CATEGORIES, BOWL_OPTIONS } from '../data/menuData';
// Types
export interface RestaurantConfig {
  WHATSAPP_NUMBER: string;
  EXPRESS_FEE: number;
  CURRENCY_SYMBOL: string;
  LOGO_URL: string;
  APP_NAME: string;
  APP_TAGLINE: string;
  OPEN_HOUR: number;
  CLOSE_HOUR: number;
  ADMIN_PIN: string;
}
export interface BowlOptions {
  bases: ProductOption[];
  proteinas: ProductOption[];
  toppings: ProductOption[];
  toppingsPremium: ProductOption[];
  aderezos: ProductOption[];
  semillas: ProductOption[];
}
interface RestaurantContextType {
  config: RestaurantConfig;
  menuProducts: Product[];
  categories: string[];
  bowlOptions: BowlOptions;
  loading: boolean;
}
const RestaurantContext = createContext<RestaurantContextType | null>(null);
export function RestaurantProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [config] = useState<RestaurantConfig>(CONFIG);
  const [menuProducts] = useState<Product[]>(MENU_PRODUCTS);
  const [categories] = useState<string[]>(CATEGORIES);
  const [bowlOptions] = useState<BowlOptions>(BOWL_OPTIONS as BowlOptions);
  const [loading] = useState(false);
  // Future: fetch config, menu, and bowl options from Supabase here
  // useEffect(() => {
  //   async function fetchRestaurantData() {
  //     setLoading(true)
  //     const { data: configData } = await supabase.from('restaurant_config').select('*').single()
  //     if (configData) setConfig(configData)
  //     const { data: menuData } = await supabase.from('menu_items').select('*')
  //     if (menuData) {
  //       setMenuProducts(menuData)
  //       setCategories([...new Set(menuData.map(p => p.category))])
  //     }
  //     const { data: bowlData } = await supabase.from('bowl_options').select('*')
  //     if (bowlData) setBowlOptions(parseBowlOptions(bowlData))
  //     setLoading(false)
  //   }
  //   fetchRestaurantData()
  // }, [])
  return <RestaurantContext.Provider value={{
    config,
    menuProducts,
    categories,
    bowlOptions,
    loading
  }} data-id="element-1691">
      {children}
    </RestaurantContext.Provider>;
}
export function useRestaurant(): RestaurantContextType {
  const context = useContext(RestaurantContext);
  if (!context) {
    throw new Error('useRestaurant must be used within a RestaurantProvider');
  }
  return context;
}